import type { UserData, AuthConfig, IdTokenProfile } from '../types/types'
import { AccessTokenData, IdTokenData } from '../types/tokenTypes'
import cookieHandler from '../handlers/cookieHandler'
import tokenHandler from '../handlers/tokenHandler'

export default (config: AuthConfig, cookieHeader?: string) => {
  const token = tokenHandler(config)
  const cookies = cookieHandler(cookieHeader)

  // The browser cannot read the id token, so it gets the profile from the server (SSR props).
  return (browserProfile?: IdTokenProfile | null): UserData | null => {
    const accessToken = token.getValidToken<AccessTokenData>(cookies.getAccessToken())

    if (!accessToken) return null

    if (typeof window !== 'undefined') {
      return token.getUserData(browserProfile ?? null, accessToken)
    }

    const idToken = token.getValidToken<IdTokenData>(cookies.getIdToken())

    if (!idToken) return null

    return token.getUserData(token.getIdTokenProfile(idToken), accessToken)
  }
}
